import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavbarContextType {
  applicationName: string | null;
  setApplicationName: (name: string | null) => void;
}

const NavbarContext = createContext<NavbarContextType | undefined>(undefined);

export const NavbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [applicationName, setApplicationName] = useState<string | null>(null);

  return (
    <NavbarContext.Provider value={{ applicationName, setApplicationName }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (context === undefined) {
    throw new Error('useNavbar must be used within a NavbarProvider');
  }
  return context;
};
